module.exports = __webpack_public_path__ + "img/baidu.482368a4.png";